export const arrayLabel = {
  "& .RaArrayInput-label": {
    fontSize: "32px",
    fontWeight: "bold",
    color: "#000",
    marginTop: "2em",
  },
};
export const richTextLabel = {
  "& .RaLabeled-label": {
    fontSize: "17px",
    fontWeight: "bold",
    color: "#000",
  },
};
export const autocompleteInput_style_reference = {
  "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
    padding: "0.5px 4px 7.5px 6px",
  },
};
export const districtStyle = {
  "& .MuiOutlinedInput-root": {
    height: "40px",
    marginTop: "4px",
  },
  "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
    padding: "0.5px 4px 7.5px 6px",
  },
};
export const autocompleteInput_style_filter_reference = {
  "& .MuiFormLabel-root": {
    top: "-3px",
  },
  "& .MuiOutlinedInput-root": {
    padding: "4px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    margin: "3px 0px 3px 0px",
    height: "44px",
  },
  minWidth: "18rem",
  width: "100%",
};
export const iterator_autocomplete = {
  "& .MuiFormLabel-root": {
    top: "0px",
  },
  "& .MuiOutlinedInput-root": {
    padding: ".4rem",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    margin: "3px 0px 3px 0px",
    height: "44px",
    top: "0px",
  },
  width: "75%",
};

export const autocompleteInput_style_filter_reference_many = {
  // "&.MuiAutocomplete-input": {
  //   padding: "7.5px 4px 3.5px 6px",
  // },
  "& .MuiOutlinedInput-notchedOutline": {
    height: "44px",
    top: "-8px",
  },
  "& .MuiFormLabel-root": {
    top: "-1px",
  },
  // "& .Mui-focused": {
  //   top: "-9px"

  // },
  minWidth: "20rem",
  width: "100%",
};
export const filterStyle = {
  marginRight: { sm: "1rem", md: "1rem", lg: "6rem", xl: "9rem" },
  marginLeft: { sm: "1rem", md: "1rem", lg: "6rem", xl: "9rem" },
  minWidth: "240px",
  maxWidth: "240px",
  width: "100%",
};
export const filterNumberStyle = {
  marginRight: { sm: "1rem", md: "1rem", lg: "6rem", xl: "9rem" },
  marginLeft: { sm: "1rem", md: "1rem", lg: "6rem", xl: "9rem" },
  minWidth: "240px",
  maxWidth: "240px",
  width: "100%",
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
};
export const datePickerFilterResponse = {
  marginRight: { sm: "1rem", md: "1rem", lg: "6rem", xl: "9rem" },
  marginLeft: { sm: "1rem", md: "1rem", lg: "6rem", xl: "9rem" },
  minWidth: "240px",
  maxWidth: "240px",
  width: "100%",
  "& .MuiOutlinedInput-root": {
    fontSize: "14px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    height: "44px",
    margin: "3px 0px 3px 0px",
    top: "-2px",
  },
  "& .MuiFormLabel-root": {
    top: "1px",
  },
};

export const nestedDatagridFormat = {
  "& .RaDatagrid-headerCell": {
    backgroundColor: "#f7de52eb",
    fontWeight: 700,
    fontSize: 16,
    color: "#000",
    zIndex: "1",
  },
  border: ".9px solid #d6d1d0a3",
  borderRadius: "5px",
  backgroundColor: "#d6d1d0a3",
};
export const raLabeledStyle = {
  marginTop: "-0.187em",
  marginRight: "1rem",
  background: "#c5bfbf",
  border: "1px solid grey",
  padding: "0.319em 0.563em",
  minHeight: "1.5rem",
  minWidth: "fit-content",
  fontWeight: "bold",
};
export const raLabeledStyleModify = {
  marginTop: "-0.187em",
  marginRight: "1rem",
  marginBottom: "1rem",
  background: "#c5bfbf",
  border: "1px solid grey",
  padding: "0.319em 1.23em",
  minHeight: "1.5rem",
  width: "132px",
  fontWeight: "bold",
};
export const raSimpleShowLayoutFlexRow = {
  flexDirection: "row",
  display: "flex",
};
export const raSimpleShowLayoutCellFlex = {
  flexDirection: "row",
  display: "flex",
  marginRight: ".8rem",
  marginTop: ".01em",
};
export const showViewdatagrid = {
  width: "400px",
  border: "1px solid lightgrey",
  margin: ".8rem 0",
  "& .RaDatagrid-headerCell": {
    textAlign: "left",
    backgroundColor: "rgb(205 199 199 / 87%)",
    color: "#625e5e",
  },
};
export const accordionTitle = { fontSize: "15px", fontWeight: "700" };
export const sectionTitle = { fontSize: "15px", fontWeight: "700" };

export const editTitle = { marginLeft: "1rem", fontWeight: "normal", color: "#da291c" };
export const customImageStyle = {
  maxHeight: "10rem",
  maxWidth: "100%",
  marginBottom: "2rem",
};
export const customDatePicker = {
  "& .MuiOutlinedInput-notchedOutline": {
    height: "44px",
    margin: "3px 0px 3px 0px",
    top: "-5px",
  },
  "& .MuiFormLabel-root": {
    top: "3px",
  },
  minWidth: "18rem",
  width: "100%",
};
export const minContainer = { minHeight: "80vh" };
